import React from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { State } from '../../../../store';
import EASkeletonLoader from '../../../shared/EASkeletonLoader';
import CardName from '../../../MyAccount/AccountCard/CardName';
import CardDescription from '../../../MyAccount/AccountCard/CardDescription';
import getDelphiNumber from '../../../../../utils/getDelphiNumber';
import QRCode from 'react-qr-code';
import CardBalance from '../../../MyAccount/AccountCard/CardBalance';
import { Link } from 'react-router-dom';
import EAButton from '../../../shared/Buttons/EAButton';
import { AiOutlineSafety } from 'react-icons/ai';
import { format } from 'date-fns';
import { ECARD_RECHARGE } from '../../../../routes';
import './EcardTab.scss';
import useFacility from "../../../../../utils/hooks/useFacility";

const EcardCard: React.FC = () => {
  const { t } = useTranslation();
  const facilityId = useFacility();
  const userData = useSelector((state: State) => state.auth.userData);
  const loading = useSelector((state: State) => state.auth.loading);
  const ecardQr = useSelector((state: State) => state.config.configuration.ecard_showBarCode);
  const ecardRegisterIncome = useSelector((state: State) => state.config.configuration.ecard_RegisterIncome);

  // Sprawdzenie czy data minęła
  const isCardExpired = userData.closeDate && new Date(userData.closeDate).getTime() < new Date().getTime();
  const isFacility273 = facilityId === "273";
  const showCashierOnlyMessage = isCardExpired && isFacility273;

  return (
    <>
      {loading ? (
        <EASkeletonLoader height="300px" />
      ) : (
        <>
          <div className="ecard-card">
            <div className="ecard-card-box">
              <div className="ecard-card-up flex-between">
                <div className="ecard-card-up-left">
                  <CardName />
                  <div className="flex-start-center">
                    <div className="flex-column">
                      <b>{t("upust")}:</b>
                      <CardDescription />
                    </div>

                    <div className="flex-column">
                      <b>{t("waznosc")}:</b>
                      {userData.closeDate ? (
                        <span>{format(userData.closeDate, "dd.MM.yyyy")}r.</span>
                      ) : (
                        <span>{t("brak")}</span>
                      )}
                    </div>
                  </div>
                </div>
                {ecardQr && (
                  <div className="qr flex-center-center flex-column">
                    <QRCode value={`EA_${getDelphiNumber(userData.account)}`} size={100} />
                    <b>{`EA_${getDelphiNumber(userData.account)}`}</b>
                  </div>
                )}
              </div>

              <div className="ecard-card-deposit flex-between-center">
                <div className="">
                  <span>{t("dostepne_srodki")}:</span>
                  <CardBalance />
                </div>
                {ecardRegisterIncome && (
                  <>
                    {showCashierOnlyMessage ? (
                      <span className="caption text-color-gray">Doładowanie możliwe tylko w kasie.</span>
                    ) : (
                      <Link to={ECARD_RECHARGE}>
                        <EAButton title={t("doladuj_karte")} startIcon={<AiOutlineSafety />} />
                      </Link>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default EcardCard